import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { ProductsContextProvider } from "../../Context/ProductsContext";
import PriceListForm from "./PriceListForm";
import useFetch from "../../../hooks/useFetch";
import Body from "../../Common/Body";

const PriceList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [priceList, setPriceList] = useState({});
  const { id } = useParams();
  const { get } = useFetch();

  useEffect(() => {
    get(`/priceLists/${id}`)
      .then(async (res) => {
        setPriceList(res);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <>
      <ProductsContextProvider>
        <Body
          title={`Lista de precios nro. ${priceList.id}`}
          isLoading={isLoading}
        >
          <Box p={["0", "0.75rem"]}>
            <PriceListForm priceList={priceList} id={id}></PriceListForm>
          </Box>
        </Body>
      </ProductsContextProvider>
    </>
  );
};

export default PriceList;
